import { LDFlagSet } from "launchdarkly-react-client-sdk";

class LDFeatureFlags {
  private flags: LDFlagSet = {};

  getFlagValue = (name: string) => {
    return this.flags?.[name];
  };

  setFlags = (flags: LDFlagSet) => {
    return this.flags = flags
  };
}

export const ldFeatureFlags = new LDFeatureFlags();
